import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "11px",
	height: "11px",
	viewBox: "7 6 11 11",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13 11h5v1h-5v5h-1v-5H7v-1h5V6h1v5z"
	})
});
export default SvgPlus;
